<template>
	<div class="basic_wrap">
		<div class="red_top_bg">
			<div class="back_left" @click="$router.back()"></div>
			<div class="big_tit">{{ $t('home.activity') }}</div>
		</div>
		<div class="item_wrap">
			<div v-for="i in data.list" :key="i.id" class="item" @click="jump(i)">
				<img :src="i['img_' + lang]">
				<p>{{ i['title_' + lang] }}</p>
				<p>{{ i.time }}</p>
			</div>
		</div>
	</div>
</template>

<script>
import Fetch from '../../utils/fetch';
import Api from "../../interface/index";

export default {
	name: "activity",
	data() {
		return {
			lang: this.$i18n.locale || "en_us",
			data: {},
		}
	},
	created() {
		this.$parent.footer('activity', false);
	},
	mounted() {

		this.start();
	},
	methods: {
		start() {
			Fetch('/index/activity_list').then(r => {
				this.data = r.data;
			})
		},
		jump(activity) {
			if (activity.url == "") {
				this.$router.push("/activity/" + activity.id);
			} else {
				this.$router.push(activity.url);
			}
		}
	},
}
</script>

<style lang="less" scoped>
.back_left {
	background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAWCAYAAADEtGw7AAAAmUlEQVRIS7XVgQmAIBCF4d8VgpZoiKAl2qwlWiJoiJYImiEEA5G0u0sd4PM83nmORsf9cAdgAaY3wwp7dA3gCFwpboFjdAaOGhWLUH+RpmIxqoFVqBRWoxLYhH7BZrQE98AWYpSNVGm4cqnogL0F7M0mrXheacYlA2LCJbCpLVJYjWtgFa6FxbgFTnG/Qc4aH30cxeqr6XNV3snLJhc9gOxwAAAAAElFTkSuQmCC) no-repeat center center;
}

.red_top_bg {
	position: fixed;
	top: 0;
	z-index: 10;
}

.basic_wrap {
	position: relative;
}

.big_tit {
	color: #000000;
}

.item_wrap {
	width: 100%;
	padding: 44px 0 0 0;

	.item {
		width: 96%;
		background: #FFFFFF;
		margin: 10px 0 10px 2%;
		border-radius: 5px;

		img {
			width: 100%;
			border-radius: 5px 5px 0 0;
		}

		p:nth-child(2) {
			padding: 10px 0 10px 10px;
			font-weight: bold;
		}

		p:nth-child(3) {
			padding: 0px 0 10px 10px;
			color: #999;
		}
	}
}
</style>
